<du-lipo-detail [detailModel]="detailModel" (onDeleteClicked)="onDeleteClicked(partnerId)"
                (onSaveClicked)="onSaveClick(detailModel!, partnerId)"
                [isSaving]="isSaving"
                [navigateBack]="{commands: [LipoRouteEnum.PARTNER]}"></du-lipo-detail>
